import { render, staticRenderFns } from "./WaybillInventory.vue?vue&type=template&id=72565950&scoped=true"
import script from "./WaybillInventory.vue?vue&type=script&lang=js"
export * from "./WaybillInventory.vue?vue&type=script&lang=js"
import style0 from "./WaybillInventory.vue?vue&type=style&index=0&id=72565950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72565950",
  null
  
)

export default component.exports